<template>
  <div class="my-20">

    <div v-if="loading_gallery_images" class="p-5 md:p-20 flex flex-col space-y-10">

        <div class="flex flex-col justify-center items-center bg-gray-100 p-5">
            <svg
                 class="w-20 h-20 m-20 text-gray-200 animate-spin dark:text-gray fill-blue"
                 viewBox="0 0 100 101"
                 xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                />
                <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                />
            </svg>
        </div>
    </div>

    <div v-else class="max-w-7xl mx-auto">
        <carousel
            ref="myGalleryCarousel"
            :items-to-show="1"
            class="mx-10"
        >
            <slide
                v-for="file in gallery_images"
                :key="file.id"
                class="flex flex-col"
            >
                <figure class="relative w-full aspect-h-9 aspect-w-16 cursor-pointer border border-2 border-transparent focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100">
                  <blur-hash
                      v-if="file.pivot?.media_crop"
                      :hash="file.custom_properties?.blur_hash"
                      :src="file.pivot.media_crop.url"
                      :alt="file.custom_properties?.description ?? file.name"
                      class="aspect-video w-full object-cover rounded-lg"
                  />
                  <blur-hash
                      v-else
                      :hash="file.custom_properties?.blur_hash"
                      :src="file.original_url"
                      :alt="file.custom_properties?.description ?? file.name"
                      class="aspect-video w-full object-cover rounded-lg"
                  />
                    <div class="w-full flex">
                        <button @click="prev" class="hover:bg-gray-700 hover:bg-opacity-25">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="white" class="w-10 h-10">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                            </svg>
                        </button>
                        <div class="grow opacity-0 hover:opacity-100 flex justify-center items-center" @click="openCrop(file)">
                          <div class="bg-gray-700 bg-opacity-25 w-1/2 h-1/2 flex flex-col justify-center items-center">
                            <svg class="m-3 text-white h-10 w-10" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                            </svg>
                            <span class="font-semibold text-white text-sm">Crop</span>
                          </div>
                        </div>
                        <button @click="next" class="hover:bg-gray-700 hover:bg-opacity-25">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="white" class="w-10 h-10">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                            </svg>
                        </button>
                    </div>

                </figure>
                <p class="pointer-events-none mt-1.5 block truncate text-xs font-medium text-font-dark">{{ file.name }}</p>
            </slide>
            <template #addons>
            </template>
        </carousel>
        <div class="mx-auto" :class="[gallery_images.length > 0 ? 'max-w-7xl mx-10' : 'bg-gray-200 w-2/3 h-128']">
          <media-picker-multiple
              :selected="gallery_images"
              :settings="{
                        proposal: {
                            name: 'Current Proposal',
                            get: route('api.proposal.media.index', {proposal: store.proposal.id}),
                            upload: route('api.proposal.media.store', {proposal: store.proposal.id})
                        }
                    }"
              :default_search="store.proposal.places[0].name"
              @update="updateGalleryMedia"
          />
        </div>
        <MediaCropper
          v-if="edit_file"
          :image="edit_file"
          @close="edit_file = null"
          @crop="saveCrop"
        />
    </div>

  </div>
</template>

<script>
// fix for console warning for attr errors
export default {
    inheritAttrs: false
}
</script>

<script setup>

import {computed, onMounted, ref} from "vue";
import MediaPickerMultiple from "@/Components/Media/MediaPickerMultiple.vue";
import MediaEditor from "@/ComponentsDeprecated/MediaEditor";
import { Carousel, Slide, Navigation } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css'
import {useProposalOldStore} from "@/Stores/ProposalOld";
import MediaCropper from "@/ComponentsDeprecated/MediaCropper";
import BlurHash from "@/ComponentsDeprecated/BlurHash";

const gallery_images = ref([])
const loading_gallery_images = ref(false)
const edit_file = ref(null)
const myGalleryCarousel = ref(null)

const store = useProposalOldStore()

function updateGalleryMedia(media) {
    loading_gallery_images.value = true
    axios.post(route('api.proposal.gallery.sync', {proposal: store.proposal.id}), {
        images: media
    }).then(response => {
        gallery_images.value = response.data.images
    }).catch(error => {
        console.log('error')
        console.log(error)
    }).finally(() => {
        loading_gallery_images.value = false
    })
}

function next() {
    myGalleryCarousel.value.next()
}
function prev() {
    myGalleryCarousel.value.prev()
}

function openCrop(file) {
  edit_file.value = file
}

function saveCrop(res) {
  axios.post(route('api.proposal.gallery.crop', {proposal: store.proposal.id, media: edit_file.value.id}), {
    media_crop: res
  }).then(response => {
    gallery_images.value[gallery_images.value.indexOf(edit_file.value)].pivot['media_crop'] = response.data
  }).catch(error => {
    console.log('error')
    console.log(error)
  }).finally(() => {
    edit_file.value = null
  })
}

onMounted(() => {
    gallery_images.value = store.proposal.gallery
})

</script>
